import React, { Component } from 'react';
import OurUncontrolledTooltip from './OurUncontrolledTooltip';
import PropTypes from 'prop-types';
import { Tooltip } from 'reactstrap';

class TryAgainToolTip extends Component  {

    constructor(props) {
        super(props);
        this.state = { errorOccured: false };
    }

    static getDerivedStateFromError(error) {
        //debugger;
        return { errorOccured: true };
    }

    componentDidCatch(error, info) {
        this.setState({ errorOccured: true });
        //super.componentDidCatch(error, info);
    }

    render() {
        const { errorOccured } = this.state;
        const { target, placement, text, className } = this.props;
        if (!errorOccured) {
            try {
                return <OurUncontrolledTooltip
                    placement={placement}
                    autohide={false}
                    target={target}
                    className={"try-again-tooltip" + (className ? " " + className : "")}
                    hideArrow
                >
                    {text}
                </OurUncontrolledTooltip>;
            }
            catch (e) {
                this.setState({ errorOccured: true });
            }
        }
        else {
            return <div></div>;
        }
    }
}

const propTypes = {
    className: PropTypes.string,    
    placement: PropTypes.string,    
    target: PropTypes.oneOfType([
        PropTypes.string,
        PropTypes.func,
        PropTypes.instanceOf(Element),
        PropTypes.shape({ current: PropTypes.any })
    ]).isRequired,
    text: PropTypes.string    
};

const defaultProps = {
    placement: 'top',
    className: '',
    text: 'Try again later'
};

TryAgainToolTip.propTypes = propTypes;
TryAgainToolTip.defaultProps = defaultProps;

export default TryAgainToolTip;